/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { REVIEWER_PERFORMANCE_MAX_DAYS } from '@repo/config';
import { z } from 'zod';

export const getReviewerPerformanceDailyV1QuerySchema = z.object({
  userId: z.string().min(1),
  days: z.coerce.number().int().min(1).max(REVIEWER_PERFORMANCE_MAX_DAYS).default(30),
});

export type IGetReviewerPerformanceDailyV1Query = z.input<
  typeof getReviewerPerformanceDailyV1QuerySchema
>;
